import { render } from "./ChangeWebsiteLanguage.vue?vue&type=template&id=32320b97&scoped=true"
import script from "./ChangeWebsiteLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeWebsiteLanguage.vue?vue&type=script&lang=js"

import "./ChangeWebsiteLanguage.vue?vue&type=style&index=0&id=32320b97&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32320b97"]])

export default __exports__